export default {"theme":{"themes":{"options":{"customProperties":true},"light":{"primary":"#E22B28","secondary":"#717171"},"dark":{"primary":"#E22B28","secondary":"#717171"}}}}
